import { Checkbox, FormControlLabel, Stack, TextField, Typography } from "@mui/material";

import { type FormState } from "../types";

type Props = {
  formState: FormState;
  onChange: (field: keyof FormState, value: string | boolean) => void;
};

export default function OrganizationDetailsStep({ formState, onChange }: Props) {
  return (
    <Stack data-cy="organization-details-step" spacing={4}>
      <Typography variant="h3">Enter your CloudZero Organization Details</Typography>
      <Typography variant="body1">1. Create and enter the Organization Name below</Typography>
      <TextField
        label="Organization Name"
        fullWidth
        value={formState.orgName}
        required
        onChange={(event) => {
          onChange("orgName", event.target.value);
        }}
        helperText="Use a friendly name that helps identify the connection"
        data-cy="organization-name-input"
      />
      <Typography variant="body1">2. Choose the type of data you want to import</Typography>
      <Stack spacing={2} mt={1}>
        <FormControlLabel
          sx={{ alignItems: "flex-start" }}
          control={
            <Checkbox
              sx={{ pt: 0 }}
              checked={formState.fetchCosts}
              onChange={(_, checked) => {
                onChange("fetchCosts", checked);
              }}
              data-cy="import-costs-checkbox"
            />
          }
          label={
            <Stack>
              <Typography>Real costs</Typography>
              <Typography variant="caption" color="text.secondary">
                This allows us to show you data about your real costs, up to <b>three months ago</b>
              </Typography>
            </Stack>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              sx={{ pt: 0 }}
              checked={formState.fetchInsights}
              onChange={(_, checked) => {
                onChange("fetchInsights", checked);
              }}
              data-cy="import-insights-checkbox"
            />
          }
          label={
            <Stack>
              <Typography>Insights</Typography>
              <Typography variant="caption" color="text.secondary">
                Get insights from CloudZero and see them in our Insights feature
              </Typography>
            </Stack>
          }
        />
      </Stack>
    </Stack>
  );
}
